import { memo } from 'react';

import { Badge, Text } from '@/components/core';
import { useImageSrc } from '@/hooks';
import { toProfileId, useGetProfile } from '@/hooks/api';
import { DivProps, OmitChildren } from '@/utils';

export type ProfileBadgeProps = OmitChildren<DivProps> & {
  profileId: string;
};

const IProfileBadge = ({ profileId, ...rest }: ProfileBadgeProps) => {
  const { data: profile } = useGetProfile(toProfileId(profileId));
  const { src } = useImageSrc({ source: profile?.pictureUrl });

  if (!profile) return null;

  return (
    <Badge className="rounded-sm py-0 pr-1.5" variant="plain" {...rest}>
      <img className="size-3 rounded-full" src={src} />
      <Text size="xs" className="font-medium text-gray-600">
        {profile.givenName ?? profile.familyName ?? profile.email}
      </Text>
    </Badge>
  );
};

export const ProfileBadge = memo(IProfileBadge) as typeof IProfileBadge;
